export var SubscriptionMetadata;
(function (SubscriptionMetadata) {
    SubscriptionMetadata["OrgID"] = "orgID";
    SubscriptionMetadata["InitiatorUserID"] = "initiatorUserID";
    SubscriptionMetadata["TaxApplied"] = "taxApplied";
})(SubscriptionMetadata || (SubscriptionMetadata = {}));
//# sourceMappingURL=subscriptionMetadata.js.map